import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import { calculatePositions } from 'utils/redux'
import { listsSelector } from '../selectors/lists'
import {
  setPositions
} from '../redux/lists'

export default function * requestPositionList (action) {
  const { listId, position } = action.payload

  const state = yield select()

  const list = state['view-myboard'].lists[listId]

  if (!list) return

  const lists = listsSelector(state)

  const positions = calculatePositions({
    array: lists,
    id: listId,
    position
  })

  const optimisticAction = yield optimisticPut(setPositions(positions))

  try {
    yield call(apiAction, 'PositionVList', {
      id: listId,
      position
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
